<p-toast position="bottom-right"></p-toast>
<p-toast key="log" position="center"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<span class="cc-header">
  <span class="cc-title">
    {{ 'page.' + this.transPartKey + '.title' | translate }}
  </span>
</span>
<!--<span class="button-container">-->
<!--      <button pButton (click)="save()" type="button"-->
<!--              class="p-button p-button-success full-width-button"-->
<!--              icon="fas fa-plus" [pTooltip]="'page.' + transPartKey + '.button.tooltip.clear' | translate"-->
<!--              [disabled]="!validateForm() || formLoading || loadingProgressValue<100"-->
<!--      ></button>-->
<!--&lt;!&ndash;      <button pButton (click)="clear()" type="button"&ndash;&gt;-->
<!--&lt;!&ndash;              class="p-button p-button-warning min-width-button"&ndash;&gt;-->
<!--&lt;!&ndash;              icon="fas fa-trash" [pTooltip]="'page.' + transPartKey + '.button.tooltip.save' | translate"&ndash;&gt;-->
<!--&lt;!&ndash;      ></button>&ndash;&gt;-->
<!--</span>-->
<span class="form-container">
<span class="button-container top">
        <button pButton (click)="save()" type="button"
                class="p-button cc-button-success full-width-button"
                [disabled]="!validateForm() || formLoading || loadingProgressValue<100"
        >
          <span class="m-0-auto d-flex">
          <i class="fa-solid fa-plus"></i>
            <span class="m-0-5">Create new ticket</span>
          </span>                                                <i><small>CTRL + ENTER</small></i>
        </button>
  <!--  [pTooltip]="'page.' + transPartKey + '.button.tooltip.clear' | translate"-->
  <!--      <button pButton (click)="clear()" type="button"-->
  <!--              class="p-button p-button-warning min-width-button"-->
  <!--              icon="fas fa-trash" [pTooltip]="'page.' + transPartKey + '.button.tooltip.save' | translate"-->
  <!--      ></button>-->
  </span>
  <app-cc-form #ccForm [transPartKey]="transPartKey"
               [loading]="formLoading" [submitted]="formSubmitted"
               [formConfig]="formConfig"
               [(formRecord)]="formRecord"
               (formRecordChange)="formRecordChanged($event); reloadFieldValueMap(); validateForm()"
               [loadingProgressValue]="loadingProgressValue"
               [globalErrorMessage]="globalErrorMessage"
  ></app-cc-form>
    <app-clearing-selection-summary [summaryBuyValue]="summaryBuyValue" [summarySellValue]="summarySellValue"
                                    [isDark]="false" [showLoadingSpinner]="false"></app-clearing-selection-summary>
  <span class="button-container bottom">
        <button pButton (click)="save()" type="button"
                class="p-button cc-button-success full-width-button"
                [disabled]="!validateForm() || formLoading || loadingProgressValue<100"
        >
          <span class="m-0-auto d-flex">
          <i class="fa-solid fa-plus"></i>
            <span class="m-0-5">Create new ticket</span>
          </span>                                                <i><small>CTRL + ENTER</small></i>
        </button>
    <!--    [pTooltip]="'page.' + transPartKey + '.button.tooltip.clear' | translate"-->
    <!--      <button pButton (click)="clear()" type="button"-->
    <!--              class="p-button p-button-warning min-width-button"-->
    <!--              icon="fas fa-trash" [pTooltip]="'page.' + transPartKey + '.button.tooltip.save' | translate"-->
    <!--      ></button>-->
  </span>
</span>
<!--<app-cc-form #ccForm [transPartKey]="transPartKey"-->
<!--             [loading]="loading" [submitted]="submitted"-->
<!--             [formConfig]="formConfig" [(formRecord)]="formRecord"-->
<!--             [loadingProgressValue]="loadingProgressValue"-->
<!--             [globalErrorMessage]="globalErrorMessage"-->
<!--             [globalInfoMessage]="globalInfoMessage"-->
<!--             (formRecordChange)="formRecordChange.emit($event); reloadFieldValueMap(); validateForm()"-->
<!--&gt;</app-cc-form>-->
